import { CreatePortfolio } from '@unistocks/features/portfolios/create-portfolio';
import { t } from '@unistocks/localization';
import Head from 'expo-router/head';

export default function CreatePortfolioScreen() {
  return (
    <>
      <Head>
        <title>{t('::Menu:Portfolios:Create')}</title>
      </Head>
      <CreatePortfolio />
    </>
  );
}
